import React from "react"
import { Chart as ChartJS, ChartType } from "chart.js"

type ExportChartProps<TType extends ChartType> = {
  chartRef: React.RefObject<ChartJS<TType>>
  fileName?: string
  scale?: number
  drawManual?: (canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D) => void
  children?: React.ReactNode
}

function ExportChartLink<TType extends ChartType>({
  chartRef,
  fileName = "chart.png",
  scale = 2,
  drawManual,
  children = "Download Chart",
}: ExportChartProps<TType>) {
  const handleExport = async () => {
    const chart = chartRef.current
    if (!chart) return

    const originalCanvas = chart.canvas
    const { width, height } = originalCanvas

    // Create a bigger offscreen canvas
    const exportCanvas = document.createElement("canvas")
    exportCanvas.width = width * scale
    exportCanvas.height = height * scale

    const ctx = exportCanvas.getContext("2d")
    if (!ctx) return

    // Scale everything drawn
    ctx.scale(scale, scale)

    // Draw existing chart onto the bigger canvas
    ctx.drawImage(originalCanvas, 0, 0)

    // Optionally draw manual overlays (scaled)
    if (drawManual) {
      drawManual(exportCanvas, ctx)
    }

    // Export
    const dataURL = exportCanvas.toDataURL("image/png")
    const link = document.createElement("a")
    link.href = dataURL
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault()
        handleExport()
      }}
    >
      {children}
    </a>
  )
}

export default ExportChartLink
